import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';
import { DeploymentApiModel } from '../models';

/**
 * Deployment API Service
 */
@Injectable({
    providedIn: 'root'
})
export class DeploymentService extends BaseApiService {

    /**
     * Get deployment information
     */
    getDeploymentInfo(): Observable<DeploymentApiModel> {
        return this.get<DeploymentApiModel>('/deployment/info')
            .pipe(map(response => response.data!));
    }

    /**
     * Get deployment status
     */
    getDeploymentStatus(): Observable<DeploymentApiModel> {
        return this.get<DeploymentApiModel>('/deployment/status')
            .pipe(map(response => response.data!));
    }
}
